<template>
    <div style="width:100%">
        <gmap-map
            :zoom="12"
            :center="pickup_position"
            class="animation"
            :style="`{width:100%; height:${height};}`"
            ref="googlemapref"
            :options="options"
        >
            <gmap-marker :icon="pickup_icon" :visible="renderPosition(pickup_position).lat !== '0'"  :animation="1" :position="pickup_position" :draggable="false"></gmap-marker>
            <gmap-marker :icon="dropoff_icon" :visible="renderPosition(dropoff_position).lat !== '0'"  :animation="1" :position="dropoff_position" :draggable="false"></gmap-marker>
        </gmap-map>
    </div>
</template>

<script>

import {gmapApi} from 'vue2-google-maps'
import {loaded} from 'vue2-google-maps'

export default {
    name: 'google-map-component',
    props:['pickup_position', 'dropoff_position', 'custom_height', 'show_travel_line'],
    data () {
        return {
            directionsService:null,
            directionsDisplay:null,
            directionsDisplay2:null,
            center: { lat: 1.383327, lng: 103.844422 },
            height:this.custom_height,
            pickup_icon: {
                url: "/../images/map-markers/pickup.png",
                scaledSize: {width: 35, height: 35},
                labelOrigin: {x: 16, y: -10}
            },
            dropoff_icon:{
                url: "/../images/map-markers/dropoff.png",
                scaledSize: {width: 35, height: 35},
                labelOrigin: {x: 16, y: -10}
            },
            options: {
                styles:[
                  {
                    "elementType": "geometry",
                    "stylers": [
                      {
                        "color": "#e6e6e6"
                      }
                    ]
                  },
                  {
                    "elementType": "labels.icon",
                    "stylers": [
                      {
                        "visibility": "off"
                      }
                    ]
                  },
                  {
                    "elementType": "labels.text.fill",
                    "stylers": [
                      {
                        "color": "#616161"
                      }
                    ]
                  },
                  {
                    "elementType": "labels.text.stroke",
                    "stylers": [
                      {
                        "color": "#e6e6e6"
                      }
                    ]
                  },
                  {
                    "featureType": "landscape.man_made",
                    "elementType": "geometry.fill",
                    "stylers": [
                      {
                        "color": "#e6e6e6"
                      }
                    ]
                  },
                  {
                    "featureType": "landscape.natural",
                    "elementType": "geometry.fill",
                    "stylers": [
                      {
                        "color": "#d6ebcc"
                      }
                    ]
                  },
                  {
                    "featureType": "poi",
                    "stylers": [
                      {
                        "visibility": "off"
                      }
                    ]
                  },
                  {
                    "featureType": "poi",
                    "elementType": "geometry",
                    "stylers": [
                      {
                        "color": "#eeeeee"
                      }
                    ]
                  },
                  {
                    "featureType": "poi",
                    "elementType": "labels.text.fill",
                    "stylers": [
                      {
                        "color": "#757575"
                      }
                    ]
                  },
                  {
                    "featureType": "poi.park",
                    "elementType": "geometry",
                    "stylers": [
                      {
                        "color": "#e5e5e5"
                      }
                    ]
                  },
                  {
                    "featureType": "poi.park",
                    "elementType": "labels.text.fill",
                    "stylers": [
                      {
                        "color": "#9e9e9e"
                      }
                    ]
                  },
                  {
                    "featureType": "road",
                    "stylers": [
                      {
                        "color": "#dedede"
                      }
                    ]
                  },
                  {
                    "featureType": "road",
                    "elementType": "geometry.fill",
                    "stylers": [
                      {
                        "color": "#ffffff"
                      }
                    ]
                  },
                  {
                    "featureType": "road.arterial",
                    "elementType": "labels.text.fill",
                    "stylers": [
                      {
                        "color": "#757575"
                      }
                    ]
                  },
                  {
                    "featureType": "road.highway",
                    "stylers": [
                      {
                        "visibility": "simplified"
                      }
                    ]
                  },
                  {
                    "featureType": "road.highway",
                    "elementType": "geometry",
                    "stylers": [
                      {
                        "color": "#dadada"
                      }
                    ]
                  },
                  {
                    "featureType": "road.highway",
                    "elementType": "labels.text.fill",
                    "stylers": [
                      {
                        "color": "#616161"
                      }
                    ]
                  },
                  {
                    "featureType": "road.local",
                    "elementType": "labels.text.fill",
                    "stylers": [
                      {
                        "color": "#9e9e9e"
                      }
                    ]
                  },
                  {
                    "featureType": "transit.line",
                    "elementType": "geometry",
                    "stylers": [
                      {
                        "color": "#e5e5e5"
                      }
                    ]
                  },
                  {
                    "featureType": "transit.station",
                    "elementType": "geometry",
                    "stylers": [
                      {
                        "color": "#eeeeee"
                      }
                    ]
                  },
                  {
                    "featureType": "water",
                    "elementType": "geometry",
                    "stylers": [
                      {
                        "color": "#c9c9c9"
                      }
                    ]
                  },
                  {
                    "featureType": "water",
                    "elementType": "geometry.fill",
                    "stylers": [
                      {
                        "color": "#cad2d3"
                      }
                    ]
                  }
                ]
            }
        }
    },
    mounted(){
        this.$refs.googlemapref.$mapPromise.then((map) => {
            var is_pickup_bound = false;
            var is_dropoff_bound = false;

            var bounds = new google.maps.LatLngBounds();

            var _pickup = this.renderPosition(this.pickup_position)
            if(_pickup.lat !== 0){
                is_pickup_bound = true
                bounds.extend(_pickup);
            }

            var _dropoff = this.renderPosition(this.dropoff_position)
            if(_dropoff.lat !== 0){
                is_dropoff_bound = true
                bounds.extend(_dropoff);
            }

            if(!is_pickup_bound || !is_dropoff_bound){
                bounds.extend(this.center)
                bounds.extend({
                    lat: 1.320513096245,
                    lng: 103.916088026231
                })
            }

            this.$refs.googlemapref.fitBounds(bounds);

            if(this.show_travel_line && is_pickup_bound && is_dropoff_bound){
                this.renderRouteOnMap(this.pickup_position, this.dropoff_position)
            }
        })
    },
    computed: {
        google: gmapApi
    },
    methods: {
        googleInit() {
            if (!this.directionsService) {
                this.directionsService = new google.maps.DirectionsService();
            }
            if (!this.directionsDisplay) {

                var polylineOptionsActual = new google.maps.Polyline({
                  strokeColor: '#e01d3d',
                  strokeOpacity: 1.0,
                  strokeWeight: 5
                });

                this.directionsDisplay = new google.maps.DirectionsRenderer({polylineOptions: polylineOptionsActual, suppressMarkers: true});

                var polylineOptionsActual2 = new google.maps.Polyline({
                  strokeColor: '#e01d3d',
                  strokeOpacity: 0.4,
                  strokeWeight: 10
                });

                this.directionsDisplay2 = new google.maps.DirectionsRenderer({polylineOptions: polylineOptionsActual2, suppressMarkers: true});

                this.directionsDisplay.setMap(this.$refs.googlemapref.$mapObject);
                // this.directionsDisplay2.setMap(this.$refs.googlemapref.$mapObject);
            }
        },
        renderRouteOnMap(origin, destination){
            this.googleInit();
            let directionsDisplay = this.directionsDisplay;
            let directionsDisplay2 = this.directionsDisplay2;
            let directionsService = this.directionsService;

            directionsService.route({
                origin: origin,
                destination: destination,
                travelMode:'DRIVING'
            }, (response, status) => {
                if (status === 'OK') {
                    directionsDisplay.setDirections(response)
                    directionsDisplay2.setDirections(response)

                    let routes = response.routes[0].legs

                    this.$emit('onRenderRouteMap', routes)

                } else {
                    console.log(status);
                    console.log(response);
                }
            })
        },
        renderPosition(position){
            var val = {
                lat: parseFloat(position ? position.lat : 0),
                lng: parseFloat(position ? position.lng : 0),
            }

            return val
        },
    }
}
</script>
